import {createI18n} from 'vue-i18n';
import zh from './locales/zh.json';

const i18n = createI18n({
    locale: 'zh', // 默認語言
    messages: {
        zh
    }
});

export default i18n;
